export const safeDivide = (numerator, denominator) =>
  !denominator ? 0 : numerator / denominator;
